/*******************************************************************************
  설  명 : 홈페이지 > 회원가입
  작성자 : 송영석
  작성일 : 2020-06-08
*******************************************************************************/
import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { config } from '@app/service/config.service';
import { ApiResponse } from '@app/service/api-response';
import { UtilService } from '@app/service/util.service';
import { CommonService } from '@app/service/common.service';

import { HAuthService } from '@home/service/auth.service';
import { HMemberService } from '@home/service/member.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';
import { CompanySearchComponent } from '@home/page/member/member-join/company-search/company-search.component';

const options: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  // size: 'lg',
  centered: true,
  windowClass: 'modal-fadeInDown'
};

declare global {
  interface Window {
    fn: any;
  }
}

@Component({
  selector: 'app-member-join',
  templateUrl: './member-join.component.html',
  styleUrls: ['./member-join.component.scss']
})
export class MemberJoinComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  errorResponse: ApiResponse;
  public form: FormGroup;
  public formErrors = {};

  public checkTrue = true;
  public agree = false;
  public authCheck = false;
  public isLoginCheck = false;

  public comNumberCheck: any;
  public authInfo: any = {};

  public tabIndex = 0;

  daumAddressOptions =  {
    class: ['btn', 'zip-btn']
  };

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private utilService: UtilService,
    private formBuilder: FormBuilder,
    private authService: HAuthService,
    private memberService: HMemberService,
    private ngZone: NgZone,
    private modalService: NgbModal
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    this.authService.getIsHomeLogin.subscribe(data => {
      this.isLoginCheck = data;
    });

    if ( this.isLoginCheck === true ) {
      this.router.navigate(['/']);
    }

    this.buildForm();
  }

  /*******************************************************************************
    설  명 : 빌드폼 생성
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  buildForm(): void {
    this.form = this.formBuilder.group({
      userId: [ '', [Validators.required, Validators.pattern('^[a-z0-9]{5,20}$')] ],
      idCheck:[ false, [Validators.required] ],
      password: [ '', [Validators.required, Validators.pattern('^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9\d].{5,19}$')] ],
      passwordConfirm: [ '', [Validators.required] ],
      userGubun: [ '1000', [Validators.required] ],
      userName: [ '', [Validators.required, Validators.pattern('^[가-힣a-zA-Z]*$')] ],
      birth: [ '', [] ],
      birthType: [ 'S', [] ],
      userEname: [ '', [] ],
      companySeq: [ '', [] ],
      companyName: [ '', [] ],
      comNumber: [ '', [Validators.pattern('^[0-9 \-]+$'), Validators.minLength(12), Validators.maxLength(12)] ],
      companyCheck: [ false, [] ],
      comDept: [ '', [] ],
      comJob: [ '', [] ],
      memberStatus: [ '1000', [Validators.required] ],
      email: [ '', [Validators.required, Validators.pattern('^[a-z0-9._-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')] ],
      emailDupCheck: [ false, [Validators.required] ],
      telephone1: [ '', [] ],
      telephone2: [ '', [] ],
      telephone3: [ '', [] ],
      mobile1: [ '', [] ],
      mobile2: [ '', [] ],
      mobile3: [ '', [] ],
      zipcode: [ '', [] ],
      address: [ '', [] ],
      addressDetail: [ '', [] ],
      smsCheck: [ true, [] ],
      emailCheck: [ true, [] ],
      gender: [ '', [] ],
      dupinfo: [ '', [Validators.required] ],
    });

    this.form.valueChanges.subscribe(data => {
      this.utilService.updateFormErrors( this.form, this.formErrors );
    });
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    window.fn  = window.fn || {};
    window.fn.namespace = window.fn.namespace || {};
    window.fn.namespace.hpAuthFunc = this.hpAuthFunc.bind(this);
    window.fn.namespace.ipinAuthFunc = this.ipinAuthFunc.bind(this);
  }

  ngDoCheck() {

  }

  /*******************************************************************************
    설  명 : 인증 실행 후 ngZone 실행
  *******************************************************************************/
  hpAuthFunc( response: any ) {
    this.ngZone.run(() => this.hpAuthCallback( response ));
  }

  ipinAuthFunc( response: any ) {
    this.ngZone.run(() => this.ipinAuthCallback( response ));
  }

  /*******************************************************************************
    설  명 : 본인인증 체크
  *******************************************************************************/
  setAuth( type: any ) {
    // console.log(this.agree);
    if ( this.agree === false ) {
      this.toastrService.error('본인인증을 진행하시려면 이용약관에 동의하셔야 합니다.', '');
    } else {
      if ( type === 'H' ) {
        window.open( config.baseUrl + '/checkplus/checkplus_main.php', 'Parent_window', 'width=500,height=550,scrollbar=yes' );
      } else if ( type === 'I' ) {
        window.open( config.baseUrl + '/ipin/ipin_request.php', 'Parent_window', 'width=500,height=550,scrollbar=yes' );
      } else {
        this.toastrService.error('정상적으로 실행하시기 바랍니다.', '');
      }
    }
  }

  /*******************************************************************************
    설  명 : 휴대폰 인증 콜백
  *******************************************************************************/
  hpAuthCallback( response: any ) {
    //console.log(response);

    this.authInfo = response;

    if ( this.authInfo !== null ) {
      this.form.patchValue({
        userName: this.authInfo.name,
        birth: this.authInfo.birthdate,
        gender: this.authInfo.gender,
        dupinfo: this.authInfo.dupinfo
      });
    }

    this.authCheck = true;
  }

  /*******************************************************************************
    설  명 : 아이핀 인증 콜백
  *******************************************************************************/
  ipinAuthCallback( response: any ) {
    //console.log(response);

    this.authInfo = response;

    if ( this.authInfo !== null ) {
      this.form.patchValue({
        userName: this.authInfo.name,
        birth: this.authInfo.birthdate,
        gender: this.authInfo.gender,
        dupinfo: this.authInfo.dupinfo
      });
    }

    this.authCheck = true;
  }

  /*******************************************************************************
    설  명 : 탭 클릭시
  *******************************************************************************/
  setTabIndex( value: any ) {
    this.tabIndex = value;

    if ( this.tabIndex == 2 ) {
      this.form.get('companySeq').setValidators([Validators.required]);
      this.form.get('companySeq').updateValueAndValidity();
      this.form.get('companyName').setValidators([Validators.required]);
      this.form.get('companyName').updateValueAndValidity();
      this.form.get('comNumber').setValidators([Validators.required]);
      this.form.get('comNumber').updateValueAndValidity();
      this.form.get('companyCheck').setValidators([Validators.required]);
      this.form.get('companyCheck').updateValueAndValidity();

      this.form.get('telephone1').clearValidators();
      this.form.get('telephone1').updateValueAndValidity();
      this.form.get('telephone2').clearValidators();
      this.form.get('telephone2').updateValueAndValidity();
      this.form.get('telephone3').clearValidators();
      this.form.get('telephone3').updateValueAndValidity();

      this.form.get('email').clearValidators();
      this.form.get('email').updateValueAndValidity();
      this.form.get('emailDupCheck').clearValidators();
      this.form.get('emailDupCheck').updateValueAndValidity();
    } else {
      if ( this.tabIndex == 1 ) {
        this.form.get('memberStatus').setValue('4000');
      } else {
        this.form.get('memberStatus').setValue('1000');
      }

      this.form.get('companySeq').clearValidators();
      this.form.get('companySeq').updateValueAndValidity();
      this.form.get('companyName').clearValidators();
      this.form.get('companyName').updateValueAndValidity();
      this.form.get('comNumber').clearValidators();
      this.form.get('comNumber').updateValueAndValidity();
      this.form.get('companyCheck').clearValidators();
      this.form.get('companyCheck').updateValueAndValidity();

      this.form.get('telephone1').setValidators([Validators.required]);
      this.form.get('telephone1').updateValueAndValidity();
      this.form.get('telephone2').setValidators([Validators.required]);
      this.form.get('telephone2').updateValueAndValidity();
      this.form.get('telephone3').setValidators([Validators.required]);
      this.form.get('telephone3').updateValueAndValidity();

      this.form.get('email').setValidators([Validators.required]);
      this.form.get('email').updateValueAndValidity();
      this.form.get('emailDupCheck').setValidators([Validators.required]);
      this.form.get('emailDupCheck').updateValueAndValidity();
    }

    if ( this.authInfo !== null ) {
      this.form.patchValue({
        userName: this.authInfo.name,
        birth: this.authInfo.birthdate,
        gender: this.authInfo.gender,
        dupinfo: this.authInfo.dupinfo
      });
    }
  }

  /*******************************************************************************
    설  명 : 아이디 중복 검사
  *******************************************************************************/
  checkIdDuplicate() {
    this.utilService.makeFieldDirtyAndUpdateErrors(this.form, this.formErrors, 'userId');

    if( this.form.get('userId').valid ) {
      this.memberService.checkIdDuplicate( this.form.get( 'userId' ).value ).then( response => {
        if( response.ResultCode ) {
          this.form.get( 'idCheck' ).setValue( true );
          this.toastrService.success( response.ResultMessage, '아이디 중복체크');
        } else {
          this.form.get( 'idCheck' ).setValue( false );
          this.toastrService.error( response.ResultMessage, '아이디 중복체크');
        }
      });
    } else {
      this.toastrService.error( '필수 입력값을 다시 한번 확인하시기 바랍니다.', '아이디 중복체크');
    }
  }

  /*******************************************************************************
    설  명 : 아이디 변경시 중복 체크 초기화
  *******************************************************************************/
  setIdCheckInit() {
    this.form.get( 'idCheck' ).setValue( false );
  }

  /*******************************************************************************
    설  명 : 이메일 중복 검사
  *******************************************************************************/
  checkEmailDuplicate() {
    this.utilService.makeFieldDirtyAndUpdateErrors(this.form, this.formErrors, 'email');

    if( this.form.get('email').valid ) {
      this.memberService.checkEmailDuplicate( this.form.get( 'email' ).value ).then( response => {
        if( response.ResultCode ) {
          this.form.get( 'emailDupCheck' ).setValue( true );
          this.toastrService.success( response.ResultMessage, '이메일 중복체크');
        } else {
          this.form.get( 'emailDupCheck' ).setValue( false );
          this.toastrService.error( response.ResultMessage, '이메일 중복체크');
        }
      });
    } else {
      this.toastrService.error( '필수 입력값을 다시 한번 확인하시기 바랍니다.', '이메일 중복체크');
    }
  }

  /*******************************************************************************
    설  명 : 이메일 변경시 중복 체크 초기화
  *******************************************************************************/
  setEmailDupCheckInit() {
    this.form.get( 'emailDupCheck' ).setValue( false );
  }

  /*******************************************************************************
    설  명 : 기업선택
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setCompanySelected() {
    const modalRef = this.modalService.open(CompanySearchComponent, options);

    // modalRef.componentInstance.selectedItem = item;

    modalRef.componentInstance.emitData.subscribe(($e) => {
      this.form.get('companySeq').setValue( $e.seq );
      this.form.get('companyName').setValue( $e.companyName );
      this.comNumberCheck = $e.comNumber;
    });

    modalRef.result.then((result) => {
    }, (reason) => {
    });
  }

  /*******************************************************************************
    설  명 : 기업 정보확인
  *******************************************************************************/
  checkCompanyNumber() {
    if ( !this.form.get( 'companySeq' ).value || this.form.get( 'companySeq' ).value == '' ) {
      this.toastrService.error( '기업명을 선택하시기 바랍니다.', '기업 정보확인');
    } else {
      this.utilService.makeFieldDirtyAndUpdateErrors(this.form, this.formErrors, 'comNumber');

      if( this.form.get('comNumber').valid ) {
        this.memberService.checkCompanyNumber( this.form.get( 'companySeq' ).value, this.form.get( 'comNumber' ).value ).then( response => {
          if( response.ResultCode ) {
            this.form.get( 'companyCheck' ).setValue( true );
            this.toastrService.success( response.ResultMessage, '기업 정보확인');
          } else {
            this.form.get( 'companyCheck' ).setValue( false );
            this.toastrService.error( response.ResultMessage, '기업 정보확인');
          }
        });
      } else {
        this.toastrService.error( '필수 입력값을 다시 한번 확인하시기 바랍니다.', '기업 정보확인');
      }
    }
  }

  /*******************************************************************************
    설  명 : 사업자번호 변경시 중복 체크 초기화
  *******************************************************************************/
  setCompanyCheckInit() {
    this.form.get( 'companyCheck' ).setValue( false );
  }

  /*******************************************************************************
    설  명 : 다음 주소 처리
  *******************************************************************************/
  setDaumAddressApi(data) {
    // 여기로 주소값이 반환
    this.form.patchValue({
      zipcode: data.zip,
      address: data.addr
    });

    $("#addressDetail").focus();
  }

  /*******************************************************************************
    설  명 : 회원가입 처리
  *******************************************************************************/
  public setMemberSave() {
    this.utilService.makeFormDirtyAndUpdateErrors(this.form, this.formErrors);

    if ( this.form.valid ) {
      this.memberService.setMemberSave( this.form ).then(response => {
        if ( response.ResultCode == true ) {
          this.toastrService.success(response.ResultMessage, '회원가입');

          this.router.navigate(['/member/join/complete']);
        } else {
          this.toastrService.error(response.ResultMessage, '회원가입');
        }
      })
      .catch(response => {
        this.errorResponse = response;
        this.utilService.handleFormSubmitError(this.errorResponse, this.form, this.formErrors);
      });
    } else {
      this.toastrService.error('필수 입력값을 확인하시기 바랍니다.', '회원가입');
    }
  }

}
